import "./NewsletterModal.styl";

import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import { fields } from "../../../common/lib/redux-fields";
import { ValidationError } from "../../../common/lib/validation";

import {
  Container,
  Row,
  Col,
  Form as BootstrapForm,
  FormGroup,
  Label,
  FormFeedback,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import ButtonWithLoader from "../Form/ButtonWithLoader";
import Input from "../Form/Input";

import { create } from "../../../common/newsletter/actions";
import {
  clearError,
  clearForm,
  setIsOpen
} from "../../../common/newsletter/actions";

const formFields = ["email", "policy"];

const formPath = "newsletterForm";

class NewsletterModal extends React.Component {
  constructor() {
    super();

    this.create = this.create.bind(this);
    this.clearError = this.clearError.bind(this);
    this.toggleAction = this.toggleAction.bind(this);
  }

  componentDidMount() {
    const { fields, clearForm } = this.props;

    fields.$reset();
    clearForm();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  async create(e) {
    const { fields } = this.props;
    const { create, clearForm } = this.props;
    e.preventDefault();
    const values = fields.$values();

    const rs = await create(values);

    if (rs && rs.status >= 200 && rs.status <= 299) {
      fields.$reset();
      clearForm(true);

      setTimeout(this.toggleAction, 3000);

      if (typeof ga !== typeof undefined) {
        window.ga("send", "event", {
          eventCategory: "email",
          eventAction: "success",
          eventLabel: "newsletter"
        });
      }
    } else {
      if (typeof ga !== typeof undefined) {
        window.ga("send", "event", {
          eventCategory: "email",
          eventAction: "error",
          eventLabel: "newsletter"
        });
      }
    }
  }

  clearError(field) {
    const { clearError } = this.props;

    clearError(field);
  }

  toggleAction() {
    const { setIsOpen, isOpen } = this.props;

    setIsOpen(!isOpen);
  }

  render() {
    const { fields, form, isSent, isOpen } = this.props;

    const dirty = Object.keys(fields.$valuesChanged()).length > 0;

    return (
      <Modal
        className="newsletter-modal"
        isOpen={isOpen}
        toggle={this.toggleAction}
      >
        <ModalHeader toggle={this.toggleAction} />
        <ModalBody>
          <Container>
            <Row className="flex-items-xs-center">
              <Col className="section-title text-xs-center" xs="12">
                Prześlemy najnowsze oferty na Twojego maila!
              </Col>
              <Col className="section-title-second-line text-xs-center" xs="12">
                Zapisz się do newslettera.
              </Col>
            </Row>
            <Row className="flex-items-xs-center">
              <Col className="text-xs-center" xs="12" sm="6">
                <BootstrapForm
                  className="contact-form row"
                  onSubmit={this.create}
                  noValidate
                >

                  <Col xs="12">
                    <Input
                      field="email"
                      placeholder="Wpisz email"
                      type="email"
                      loading={form.get("loading")}
                      error={form.get("error")}
                      clearError={this.clearError.bind(this, "email")}
                      {...fields.email}
                    />
                    <Input
                      className="form-group-last"
                      field="policy"
                      title="Akceptuję politykę prywatności"
                      type="checkbox"
                      loading={form.get("loading")}
                      error={form.get("error")}
                      clearError={this.clearError.bind(this, "policy")}
                      formPath={formPath}
                      {...fields.policy}
                    />
                  </Col>

                  <Col xs="12">
                    {ValidationError.isInvalid(form.get("error"), "all") &&
                      <FormFeedback className="form-error">
                        Błąd wysyłania formularza lub mail został już dodany.
                      </FormFeedback>}
                    {isSent &&
                      <FormFeedback className="form-success">
                        Zostałeś zapisany do newslettera. Dziękujemy!
                      </FormFeedback>}
                    <ButtonWithLoader
                      className="button-loader"
                      size="lg"
                      color={"primary"}
                      text={"Wprowadź email"}
                      isLoading={form.get("loading")}
                      loadingText={"Subskrybuję emaila..."}
                      isDirty={dirty}
                      dirtyText={"Wyślij"}
                    />
                  </Col>
                </BootstrapForm>
              </Col>
            </Row>

          </Container>
          <div className="text-danger font-weight-bold" />
        </ModalBody>

      </Modal>
    );
  }
}

NewsletterModal.contextTypes = {
  router: React.PropTypes.object.isRequired
};

NewsletterModal = fields(NewsletterModal, {
  path: formPath,
  fields: formFields,
  getInitialState: () => {
    return {
      email: "",
      policy: false
    };
  }
});

NewsletterModal = connect(
  state => ({
    form: state.newsletter.form,
    isSent: state.newsletter.isSent,
    isOpen: state.newsletter.isOpen
  }),
  { create, clearError, clearForm, setIsOpen }
)(NewsletterModal);

export { NewsletterModal, formFields };



/** WEBPACK FOOTER **
 ** ./src/browser/components/NewsletterModal/NewsletterModal.js
 **/